<!--
 * @Descripttion: 
 * @version: 
 * @Author: jing
 * @Date: 2021-03-19 14:06:30
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-07-21 23:58:58
-->
<template>
  <div class="vcard4" v-if="cardUserInfo">
    <!-- banner -->
    <div class="banner">
      <swiper
        class="banner_swiper"
        ref="bannerSwiper"
        :options="banner.swiperOption"
      >
        <swiperSlide v-for="(item, index) in banner.items" :key="index">
          <img :src="item.main_img" @click="tapBanner(item)" />
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!--名片信息 -->
    <div class="user_info">
      <div class="user_info_container">
        <div class="user_info_msg">
          <div class="user_info_wrap">
            <div class="user_info_name act_text_ellipsis_line1">
              {{
                cardUserInfo && cardUserInfo.fansInfo
                  ? cardUserInfo.fansInfo.ui_name || cardUserInfo.fansInfo.name
                  : ""
              }}
            </div>
            <div class="user_info_role">
              <img class="img-role" :src="baseUrl + 'vcard4/role.png'" alt="" />
              <span
                class="role_name"
                v-if="cardUserInfo && cardUserInfo.fansInfo"
                >{{ cardUserInfo.fansInfo.roleid | formatRole }}</span
              >
            </div>
          </div>
          <div class="user_info_proname">
            项目名称：{{
              pcConfig && pcConfig.card
                ? pcConfig.card.projectname
                : cardUserInfo && cardUserInfo.fansInfo
                ? cardUserInfo.fansInfo.projectname
                : ""
            }}
          </div>
        </div>
        <img
          class="user_info_avatar"
          :src="
            cardUserInfo && cardUserInfo.fansInfo
              ? cardUserInfo.fansInfo.ui_headimg ||
                cardUserInfo.fansInfo.headimgurl
              : 'http://assets.rurushishi.com/yq-rs-make/huafa/default-head.png'
          "
          alt=""
        />
      </div>
      <!-- 线 -->
      <img class="line-img" :src="baseUrl + 'vcard4/line-img.png'" alt="" />
      <!-- nav -->
      <div class="btninfo-wrap">
        <div
          class="btn-item"
          @click="clickNavItem(item.click)"
          v-for="(item, index) in navData"
          :key="index"
        >
          <img class="btn-img" :src="`${baseUrl}${item.ico}`" alt="" />
          <div class="btn-name">价格:{{ item.name }}</div>
        </div>
      </div>
    </div>

    <!-- 围观 -->
    <div class="watch" @click="clickWatch">
      <div class="watch-people">
        <div
          class="watch-avatar"
          v-for="(item, index) in watchData.list"
          :key="index"
        >
          <img :src="item.userimg" alt="" />
        </div>
        <div class="head8" v-if="watchData.list && watchData.total > 5">
          ...
        </div>
        <div class="watch-p-nmber">{{ watchData.total || 0 }}围观</div>
      </div>
      <div class="watch-number">
        <img class="hot" :src="baseUrl + 'vcard4/hot.png'" alt="" />
        <span>{{ pcConfig.card ? pcConfig.card.shareCount || 0 : 0 }}</span>
      </div>
    </div>

    <!-- 推荐户型 -->
    <div class="house-title">推荐户型</div>
    <div class="house">
      <div
        class="house-item"
        v-for="(item, index) in pcConfig.houseimgs"
        :key="index"
        @click="clickHouse(item)"
      >
        <img :src="item.main_img" alt="" />
        <div class="house_tp">
          <div class="house_tags">
            <span
              class="house_tag"
              v-for="(item2, index2) in item.tags"
              :key="index2"
            >
              {{ item2 }}</span
            >
          </div>
          <div class="house_price">{{ item.price }}</div>
        </div>
      </div>
    </div>

    <div
      ref="dragBox"
      class="consult-wrap"
      @touchstart="touchstartHandle('dragBox', $event)"
      @touchmove="touchmoveHandle('dragBox', $event)"
      @touchend="touchendHandle('dragBox', $event)"
    >
      <img :src="cardUserInfo.ui.headimg" alt="" />
      <div class="consult-text">咨询</div>
    </div>
    <!-- 底部tab -->

    <Tabbar
      v-if="tabData.length"
      @clickTabbar="clickTabbar"
      :btns="tabData"
    ></Tabbar>
    <ShowImg2
      v-if="showImg2.isShow"
      :my="showImg2"
      v-on:close="showImg2.isShow = false"
    ></ShowImg2>
    <BtnBackHome></BtnBackHome>

    <van-popup
      v-model="showPopUp"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '24%' }"
    >
      <div class="leaveTel">
        <div class="tel-title">
          {{ orderType == 8 ? "留电获得专属服务" : "预约手机号" }}
        </div>
        <div class="tel-bottom">
          <div class="tb-left">
            <input
              v-model="orderTel"
              id="inputPhoneId"
              class="inputPhone"
              type="number"
              placeholder="请输入您的电话"
            />
          </div>
          <div class="tb-right" @click="submitMobile">提交</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="预约时间"
        :min-date="minDate"
        :formatter="formatOrderTime"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
import request from "@/utils/request";
import global_ from "@/global.config";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import * as qywxApi from "@/views/qywx/qywxApi";
import qywxConst from "@/views/qywx/const";
const ShowImg2 = () => import("@/components/showimg2.vue");
const BtnBackHome = () => import("@/components/btn_backhome.vue");
const Tabbar = () => import("@/views/vcard/vcard4/Tabbar");
import Cookies from "js-cookie";
import Canvastoimg from "wtc-canvastoimg";
import wxsdk from "@/utils/wxsdk";
import { MessageBox } from "mint-ui";

export default {
  name: "vcard4",
  components: {
    swiper,
    swiperSlide,
    ShowImg2,
    BtnBackHome,
    Tabbar
  },
  data() {
    return {
      baseUrl: "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/",
      cardUserInfo: null, //名片信息
      qwQrCodeUrl: "", //企微二维码
      qwQrCodePoster: "", //企微海报
      usercardopenid: "",
      navData: [
        {
          name: "微信",
          click: "clickWx",
          ico: "vcard4/qwchat.png"
        },
        {
          name: "一键致电",
          click: "clickCall",
          ico: "vcard4/tel.png"
        },
        {
          name: "存通讯录",
          click: "clickAddContact",
          ico: "vcard4/adbook.png"
        },
        {
          name: "导航",
          click: "clickAddress",
          ico: "vcard4/nav.png"
        }
      ],
      banner: {
        swiperOption: {
          autoplay: {
            delay: 2500
          },
          pagination: {
            el: ".swiper-pagination"
          }
        },
        items: []
      },
      //获取项目信息
      pcConfig: {
        callBtn: null, //致电 btns type 8
        navBtn: null, // 导航 btns type 9
        askBtn: null, // 咨询 btns type 10
        btns: [], //自定义按钮
        card: null //用户名片信息
      },
      uuid: "", //前端生成的唯一id
      cookieKeys: {
        cardid: "usercard4_cardid",
        uuid: "userCard4_uuid",
        masteropenid: "usercard4_masteropenid",
        projectid: "usercard4_projectid"
      },
      tabData: [],
      watchData: [],
      //用于拖拽
      coordinate: {
        client: {},
        elePosition: {},
        longClick: 0
      },

      cookieDuration: new Date(new Date().getTime() + 60 * 1000 * 10),
      projectList: [],
      address: "",
      gps: null,
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },

      buildingName: "",

      //留电
      showPopUp: false,
      orderType: -1,
      orderTel: "",
      //预约
      showDatePicker: false,
      minDate: new Date(),
      currentDate: new Date(),
      orderTime: ""
    };
  },
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  watch: {},
  filters: {
    formatRole: function(value) {
      var tmpObj = {
        roleid: value,
        rolename: ""
      };
      if (tmpObj.roleid == 2011) {
        tmpObj.rolename = "销售顾问";
      } else if (tmpObj.roleid == 2012) {
        tmpObj.rolename = "案场经理";
      } else if (tmpObj.roleid == 2013) {
        tmpObj.rolename = "销售经理";
      } else if (tmpObj.roleid == 2015) {
        tmpObj.rolename = "案场管理人";
      }
      return tmpObj.rolename;
    }
  },
  methods: {
    ...mapMutations({
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO"
    }),
    //移动开始
    touchstartHandle(refName, e) {
      let that = this;
      that.coordinate.longClick = 0;
      setTimeout(function() {
        that.coordinate.longClick = 1;
      }, 200);

      let element = e.targetTouches[0];
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY
      };
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft;
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop;
      e.preventDefault();
    },
    //移动中
    touchmoveHandle(refName, e) {
      let element = e.targetTouches[0];
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x =
        this.coordinate.elePosition.left +
        (element.clientX - this.coordinate.client.x);
      let y =
        this.coordinate.elePosition.top +
        (element.clientY - this.coordinate.client.y);
      // 限制可移动距离，不超出可视区域
      x =
        x <= 0
          ? 0
          : x >= innerWidth - this.$refs[refName].offsetWidth
          ? innerWidth - this.$refs[refName].offsetWidth
          : x;
      y =
        y <= 0
          ? 0
          : y >= innerHeight - this.$refs[refName].offsetHeight
          ? innerHeight - this.$refs[refName].offsetHeight
          : y;
      // 移动当前元素
      this.$refs[refName].style.left = x + "px";
      this.$refs[refName].style.top = y + "px";
    },
    //移动结束
    touchendHandle: function(refName, e) {
      if (!this.coordinate.longClick) {
        this.clickChat();
      }
      return false;
    },
    //设置uuid
    setUuid: function() {
      var uuid = Cookies.get("userCard4_uuid");
      if (uuid) {
        this.uuid = uuid;
      } else {
        this.uuid = util.getGuid();
        Cookies.set(this.cookieKeys.uuid, this.uuid, {
          expires: this.cookieDuration
        });
      }
    },
    //点击banner
    tapBanner(item) {
      if (item.redirect_url) {
        util.openUrl(item.redirect_url);
      }
    },

    //点击nav
    clickNavItem(click) {
      if (click == "clickWx") {
        this.clickWx();
      } else if (click == "clickCall") {
        this.clickCall();
      } else if (click == "clickAddContact") {
        this.clickAddContact();
      } else if (click == "clickAddress") {
        this.clickAddress();
      }
    },
    //点击tab
    clickTabbar(item, index) {
      this.tabData.forEach(item => {
        item.isActive = false;
      });
      this.tabData[index].isActive = true;
      this.saveBtnClick(item.id);
      if (item.type == 7) {
        // 预约
        this.orderType = 7;
        this.currentDate = new Date();
        this.minDate = new Date();
        this.showDatePicker = true;
        // this.showCard();
      } else if (item.type == 8) {
        // 留电
        this.orderType = 8;
        this.showPopUp = true;
        // this.showCard();
      } else {
        if (item.redirect_url.indexOf(".rushinews.com/h5/t") > -1) {
          // 我们自己的h5
          window.location.href = item.redirect_url + "&from=card";
        } else {
          window.location.href = item.redirect_url;
        }
      }
    },
    submitMobile() {
      if (!this.orderTel.length) {
        return MessageBox.alert("请输入手机号", "提示");
      } else if (!util.isMobile(this.orderTel)) {
        return MessageBox.alert("请填写正确的手机号", "提示");
      } else {
        this.saveMobile();
      }
    },
    saveMobile() {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveMobile",
            requestParam: {
              uuid: that.uuid,
              mobile: that.orderTel,
              ordertime: that.orderTime
            }
          })
          .then(function(response) {
            if (response.obj) {
              // var data = response.obj;
              that.showPopUp = false;
              that.showDatePicker = false;
              if (that.orderType == 7) {
                return MessageBox.alert("预约成功！", "提示");
              } else if (that.orderType == 8) {
                return MessageBox.alert("留电成功！", "提示");
              }
            }
          });
      });
    },
    formatOrderTime: function(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    onDateConfirm(time) {
      this.orderTime = util.getFullTime(time);
      this.showDatePicker = false;
      this.showPopUp = true;
    },
    // 微信 isFromCreated 为真的时候只是提前调用下但不弹框
    clickWx(isFromCreated) {
      let that = this;
      if (!that.cardUserInfo || !that.cardUserInfo.fansInfo.projectid) {
        that.clickAddWeChat();
        return;
      }
      if (!that.qwQrCodeUrl) {
        qywxApi
          .getExtUserIdByOpenid({
            openid: that.cardUserInfo.fansInfo.openid,
            accountType: "qywx",
            projectid:
              that.$route.query.projectId ||
              that.cardUserInfo.fansInfo.projectid
          })
          .then(res => {
            if (res.data && res.data.userid && res.data.accountOrgid) {
              qywxApi
                .getCorpUserCard({
                  corpId: res.data.accountOrgid,
                  appMark: qywxConst.appMark,
                  appType: 0,
                  type: 1,
                  scene: 2,
                  style: 1,
                  user: [res.data.userid],
                  businessData: {
                    sceneCode: "personal_user_card"
                  },
                  projectId:
                    that.$route.query.projectId ||
                    that.cardUserInfo.fansInfo.projectid
                })
                .then(res1 => {
                  if (res1.code == 0 && res1.data && res1.data.qr_code) {
                    that.qwQrCodeUrl = res1.data.qr_code;
                    that.navData = that.navData.map(item => {
                      if (item.click == "clickWx") {
                        item.name = "加我企微";
                      }
                      return item;
                    });
                    that.createQwQrCodePoster(isFromCreated);
                  } else {
                    that.clickAddWeChat(isFromCreated);
                  }
                });
            } else {
              that.clickAddWeChat(isFromCreated);
            }
          });
      } else {
        that.createQwQrCodePoster();
      }
    },
    //微信
    clickAddWeChat(isFromCreated) {
      if (!isFromCreated) {
        if (this.cardUserInfo) {
          if (!this.isInMiniProgram && this.cardUserInfo.ui.wechatqrcode) {
            // h5环境下有二维码，弹出二维码
            this.showImg2 = {
              isShow: true,
              url: this.cardUserInfo.ui.wechatqrcode,
              width: "50%",
              intro: `扫码，添加${this.cardUserInfo.ui.name}的微信！`
            };
          } else if (this.cardUserInfo.ui.wechatno) {
            util.messageBox(`我的微信号是：${this.cardUserInfo.ui.wechatno}`);
          } else {
            util.messageBox("亲，您可以用电话联系我");
          }
        } else {
          util.messageBox("亲，您可以用电话联系我");
        }
      }
    },
    //企业微信
    clickQw(isFromCreated) {
      if (!this.isInMiniProgram && this.qwQrCodeUrl && !isFromCreated) {
        this.showImg2 = {
          isShow: true,
          url: this.qwQrCodeUrl,
          width: "50%",
          intro: `扫码，添加${this.cardUserInfo.ui.name}的企业微信！`
        };
      }
    },
    //生成二维码
    createQwQrCodePoster(isFromCreated) {
      // console.log("生成二维码", isFromCreated);
      if (this.qwQrCodePoster) {
        // this.showImgUrl = this.qwQrCodePoster;
        this.showImg2 = {
          url: this.qwQrCodePoster,
          width: "70%",
          intro: "亲，请长按保存！",
          isShow: true
        };
        return;
      }
      let bgWidth = 510;
      let bgHeight = 0; //根据文字高度动态计算
      let sharpness = 2;
      let labelX = 30;
      let baseY = 490;
      let lineHeight = 50 * sharpness;
      let cvsImgData = [
        {
          type: "img",
          zIndex: 2,
          x: 0,
          y: 0,
          width: bgWidth * sharpness,
          height: 458 * sharpness,
          content: "https://assets.rurushishi.com/yq-rs-h5/qwqrcode_bg2.png"
        },
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 3,
          x: ((bgWidth - 300) / 2) * sharpness,
          y: ((458 - 300) / 2) * sharpness,
          width: 300 * sharpness,
          height: 300 * sharpness,
          content: this.qwQrCodeUrl
        },
        {
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: baseY * sharpness,
          content: this.cardUserInfo.fansInfo.name,
          fontSize: `${30 * sharpness}px 微软雅黑`,
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          x:
            (labelX +
              util.getStrBlen(this.cardUserInfo.fansInfo.name) * (30 / 2) +
              20) *
            sharpness,
          y: (baseY + 5) * sharpness,
          content: this.cardUserInfo.fansInfo.mobile,
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#333333"
        },
        {
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: (baseY + 10) * sharpness + lineHeight,
          content: "楼盘项目:",
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#999999"
        },
        {
          type: "text",
          zIndex: 2,
          x: (labelX + util.getStrBlen("楼盘项目:") * (30 / 2)) * sharpness,
          y: (baseY + 10) * sharpness + lineHeight,
          content:
            this.pcConfig.card.projectname ||
            this.cardUserInfo.fansInfo.projectname,
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#333333"
        }
      ];
      if (this.cardUserInfo.fansInfo.ui_address) {
        let maxYItem = this.getMaxYData(cvsImgData);
        cvsImgData.push({
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: maxYItem.y + lineHeight,
          content: "地      址:",
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#999999"
        });

        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = this.cardUserInfo.fansInfo.ui_address;

        // title = "一二三四五六七八九十一";
        // title = "一二三四五六七八九十一二三四五六七八九十";
        // title =
        // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
        for (let index = 0; index < title.length; index++) {
          if (
            tmpStrListIndex == 0 ||
            tmpStrListIndex >= 24 * tmpStrList.length
          ) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += util.getStrBlen(title[index]);
        }
        let stringYStartValue = maxYItem.y + lineHeight;
        // 最多展示三行
        // if (tmpStrList.length > 3) {
        //   tmpStrList = tmpStrList.slice(0, 3);
        // }
        let stringX = labelX + util.getStrBlen("一二三四:") * (30 / 2);
        for (let index = 0; index < tmpStrList.length; index++) {
          let stringY = 0;
          if (tmpStrList.length == 1) {
            // stringX =
            //   60 +
            //   (255 - (util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
            // stringX = 60;
            stringY = stringYStartValue;
          } else {
            // stringX = 60;
            stringY = stringYStartValue + 40 * sharpness * index;
          }
          let item = {
            type: "text",
            zIndex: 4,
            fontSize: `${26 * sharpness}px 微软雅黑`,
            x: stringX * sharpness,
            y: stringY,
            content: tmpStrList[index],
            color: "#333333"
          };
          cvsImgData.push(item);
        }
      }
      if (this.cardUserInfo.fansInfo.ui_personalprofile) {
        let maxYItem = this.getMaxYData(cvsImgData);
        cvsImgData.push({
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: maxYItem.y + lineHeight,
          content: "个性签名:",
          fontSize: `${26 * sharpness}px 微软雅黑`,
          color: "#999999"
        });

        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = this.cardUserInfo.fansInfo.ui_personalprofile;

        // title = "一二三四五六七八九十一";
        // title = "一二三四五六七八九十一二三四五六七八九十";
        // title =
        // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
        for (let index = 0; index < title.length; index++) {
          if (
            tmpStrListIndex == 0 ||
            tmpStrListIndex >= 24 * tmpStrList.length
          ) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += util.getStrBlen(title[index]);
        }
        let stringYStartValue = maxYItem.y + lineHeight;
        // 最多展示三行
        // if (tmpStrList.length > 3) {
        //   tmpStrList = tmpStrList.slice(0, 3);
        // }
        let stringX = labelX + util.getStrBlen("个性签名:") * (30 / 2);
        for (let index = 0; index < tmpStrList.length; index++) {
          let stringY = 0;
          if (tmpStrList.length == 1) {
            // stringX =
            //   60 +
            //   (255 - (this.$util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
            // stringX = 60;
            stringY = stringYStartValue;
          } else {
            // stringX = 60;
            stringY = stringYStartValue + 40 * sharpness * index;
          }
          let item = {
            type: "text",
            zIndex: 4,
            fontSize: `${26 * sharpness}px 微软雅黑`,
            x: stringX * sharpness,
            y: stringY,
            content: tmpStrList[index],
            color: "#333333"
          };
          cvsImgData.push(item);
        }
      }
      let maxYItem = this.getMaxYData(cvsImgData);
      bgHeight = maxYItem.y + 60 * sharpness;
      const cvsimg = new Canvastoimg({
        width: bgWidth * sharpness, //画布宽度
        height: bgHeight, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData
      });
      cvsimg.down().then(canvas => {
        /* 获取到的是canvas对象 */
        this.qwQrCodePoster = canvas.toDataURL("image/jpg");
        if (!isFromCreated) {
          // this.showImgUrl = this.qwQrCodePoster;
          // this.isShowImg = true;
          this.showImg2 = {
            url: this.qwQrCodePoster,
            width: "70%",
            intro: "亲，请长按保存！",
            isShow: true
          };
        }
      });
    },
    getMaxYData(cvsImgData) {
      let item = null;
      for (let index = 0; index < cvsImgData.length; index++) {
        if (index < cvsImgData.length - 1) {
          if (cvsImgData[index].y < cvsImgData[index + 1].y) {
            item = cvsImgData[index + 1];
          } else {
            item = cvsImgData[index];
          }
        }
      }
      return item;
    },
    //一键致电
    clickCall() {
      util.makePhoneCall(
        this.cardUserInfo.ui.mobile || this.cardUserInfo.mobile
      );
      if (this.pcConfig.callBtn && this.pcConfig.callBtn.id) {
        this.saveBtnClick(this.pcConfig.callBtn.id);
      }
    },
    //存通讯录
    clickAddContact() {
      util.messageBox("请长按复制我的手机号：" + this.cardUserInfo.ui.mobile);
    },
    //导航
    clickAddress() {
      if (this.pcConfig.navBtn && this.pcConfig.navBtn.id) {
        this.saveBtnClick(this.pcConfig.navBtn.id);
      }
      // if (this.isInMiniProgram && this.gps) {
      //   wx.openLocation({
      //     latitude: parseFloat(this.gps.lat), // 纬度，浮点数，范围为90 ~ -90
      //     longitude: parseFloat(this.gps.lng), // 经度，浮点数，范围为180 ~ -180。
      //     name: this.buildingName, // 位置名
      //     address: this.address, // 地址详情说明
      //     scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
      //     infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
      //   });
      // } else {
      //   util.openUrl(
      //     `http://uri.amap.com/marker?position=${this.gps.lng},${
      //       this.gps.lat
      //     }&name=${this.buildingName}`
      //   );
      // }
      if (this.pcConfig.card.navigationurl) {
        location.href = this.pcConfig.card.navigationurl;
      }
    },
    //点击咨询
    clickChat() {
      // util.openShqcWebChat2(
      //   this.cardUserInfo.fansInfo.openid,
      //   this.cardUserInfo.ui_name || this.cardUserInfo.name
      // );

      if (this.pcConfig.askBtn && this.pcConfig.askBtn.id) {
        this.saveBtnClick(this.pcConfig.askBtn.id);
      }
      let that = this;
      window.location.href = `${location.protocol}//${
        location.host
      }/marketies/qwdesk/pages/fans/sale-fans-interaction?receiveropenid=${
        that.cardUserInfo.fansInfo.openid
      }&projectid=${this.$route.query.projectId ||
        this.cardUserInfo.fansInfo.projectid}
      `;
    },
    //跳转到户型详情
    clickHouse(item) {
      this.$router.push(
        `/vcard4/layoutDetail?layoutId=${item.id}&usercardopenid=${
          this.$route.query.usercardopenid
        }&projectId=${this.$route.query.projectId ||
          this.cardUserInfo.fansInfo.projectid}`
      );
    },
    //记录点击事件
    saveBtnClick(btnid = "") {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveBtnClick",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                masteropenid: that.cardUserInfo.fansInfo.openid, //当前电子名片所属人的openid
                uuid: that.uuid, //前端生成的唯一标识
                btnid: btnid //功能按钮的id
              }
            }
          })
          .then(function(response) {
            if (response.obj) {
              // var data = response.obj;
            }
          });
      });
    },
    //获取围观
    getWatchData() {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/listCardUser",
            vericode: "",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                masteropenid: that.cardUserInfo.fansInfo.openid, //当前电子名片所属人的openid
                offset: 0,
                size: 4,
                order: 1
              }
            }
          })
          .then(function(response) {
            console.log("获取围观人数", response);
            if (response.obj) {
              if (response.obj.list && response.obj.list.length > 5) {
                response.obj.list = response.obj.list.slice(0, 5);
              }
              that.watchData = response.obj;
            }
          });
      });
    },
    //点击围观
    clickWatch() {
      // let link = `${location.protocol}//${
      //   location.host
      // }/marketies/desk/pages/fans/fans-audience?regfrom=sale`;
      // window.location.href = link;
    },
    //获取推荐项目
    getRecommendProject(usercardopenid) {
      //推荐项目
      comreq.displaySalerProjectPages(usercardopenid).then(data => {
        if (data && data.list && data.list.length > 0) {
          data.list = data.list.map(item => {
            if (item.extinfo) {
              item.extinfo = JSON.parse(item.extinfo);
              if (item.extinfo.advantage) {
                item.extinfo.advantage = item.extinfo.advantage.split(",");
              }
            }
            return item;
          });
          if (this.global.isLoc) {
            // data.list = data.list.concat(data.list);
            // data.list = data.list.concat(data.list);
          }
          this.address = data.list[0].extinfo.address;
          this.buildingName = data.list[0].extinfo.buildingName;
          this.gps = {
            lng: data.list[0].extinfo.lng,
            lat: data.list[0].extinfo.lat
          };
          this.projectList = data.list;
        }
        console.log("推荐项目", JSON.parse(JSON.stringify(data)));
      });
    },
    //获取项目信息
    selectCardByProjectid(usercardopenid, projectid) {
      let that = this;
      request
        .get(global_.API_URL, {
          action: "/electroniccard/ElectronicCardAction/getElectronicCard",
          requestParam: {
            projectid: parseInt(projectid),
            state: 1,
            masteropenid: usercardopenid
          }
        })
        .then(function(response) {
          console.log("户型详情----", response);
          var data = response.obj;

          //处理底部tab
          data.btns.forEach(item => {
            item.isActive = false;
            if (!item.btn_img) {
              item.btn_img =
                "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/icon-default.png";
            }
          });
          let tabData = data.btns.filter(item => item.name);
          that.tabData = tabData;

          //户型图
          if (data.houseimgs) {
            data.houseimgs.forEach(function(e) {
              if (e.tags) {
                e.tags = e.tags.split(",");
              }
            });
          }
          that.pcConfig.houseimgs = data.houseimgs;

          that.pcConfig.card = data;

          that.banner.items = data.banner; //轮播图

          //点击事件
          if (data.btns) {
            data.btns.forEach(function(e) {
              if (e.type == 9) {
                that.pcConfig.callBtn = e;
              } else if (e.type == 10) {
                that.pcConfig.navBtn = e;
              } else if (e.type == 11) {
                that.pcConfig.askBtn = e;
              } else {
                that.pcConfig.btns.push(e);
              }
            });
          }

          that.setShareInfo();
          that.clickWx(true);
          that.getWatchData();

          console.log(
            "pcConfig----",
            JSON.parse(JSON.stringify(that.pcConfig))
          );
        })
        .catch(err => {
          //   console.log(err);
        });
    },

    //获取名片信息
    getUserInfoAndFansInfo() {
      let usercardopenid = this.$route.query.usercardopenid;
      if (this.global.isLoc && !usercardopenid) {
        usercardopenid = this.$openid;
      }
      comreq.getUserInfoAndFansInfo(usercardopenid).then(data => {
        this.cardUserInfo = data;
        console.log("获取名片信息-----", JSON.parse(JSON.stringify(data)));
        if (!data || !data.fansInfo || !data.fansInfo.projectid) {
          return;
        }
        this.selectCardByProjectid(
          this.usercardopenid,
          this.$route.query.projectId || data.fansInfo.projectid
        );
      });
    },
    //设置分享
    setShareInfo() {
      global_.SHARE_TITLE = `我是${this.pcConfig.card.projectname ||
        this.cardUserInfo.fansInfo.projectname ||
        this.cardUserInfo.ui.company}的${this.cardUserInfo.fansInfo.ui_name ||
        this.cardUserInfo.fansInfo.name ||
        this.cardUserInfo.ui.name ||
        this.cardUserInfo.user.name}，欢迎您随时联系`;
      global_.SHARE_DESC = `手机号：${this.cardUserInfo.ui.mobile} ${
        this.cardUserInfo.ui.wechatno
          ? "微信号：" + this.cardUserInfo.ui.wechatno
          : ""
      }`;
      global_.SHARE_IMG_URL =
        this.cardUserInfo.ui.headimg ||
        this.cardUserInfo.fansInfo.ui_headimg ||
        this.cardUserInfo.fansInfo.headimgurl ||
        this.cardUserInfo.user.headimgurl;
      wxsdk.init();
    }
  },
  created() {
    util.checkMapStateCallback(this, ["userInfo"]).then(() => {
      let usercardopenid = this.$route.query.usercardopenid;
      if (this.global.isLoc && !usercardopenid) {
        usercardopenid = this.$openid;
      }
      this.usercardopenid = usercardopenid;
      this.setUuid();
      this.getUserInfoAndFansInfo();
    });
  }
};
</script>

<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}

.vcard4 {
  background: #F9FAFE;
  padding-bottom: p2r(130px);
}

/* Banner */
.banner_swiper {
  width: 100%;
  /* height: 4.97rem; */
}

.banner_swiper img {
  width: 100%;
  /* height: 4.97rem; */
  /* object-fit: cover; */
}

.user_info {
  width: 90%;
  margin: p2r(30px) auto p2r(9px);
  background-color: #fff;
  border-radius: p2r(20px) p2r(20px) p2r(20px) p2r(20px);
}

.user_info_container {
  display: flex;
  width: 100%;
  box-shadow: 0px p2r(2px) p2r(11px) 0px rgba(225, 225, 226, 0.57);
  border-radius: p2r(20px) p2r(20px) 0 0;
  padding: p2r(32px) p2r(44px) p2r(38px) p2r(44px);
  box-sizing: border-box;
  background-color: #fff;
}

.user_info_msg {
  flex: 1;
}

.user_info_avatar {
  width: p2r(94px);
  height: p2r(94px);
  border-radius: 50%;
  margin-left: p2r(20px);
}

.line-img {
  display: block;
  width: 100%;
  height: p2r(10px);
}

.user_info_wrap {
  display: flex;
  align-items: center;
  margin-bottom: p2r(11px);
  line-height: p2r(38px);
}

.user_info_name {
  // flex :1;
  max-width: p2r(300px);
  font-size: p2r(36px);
  font-weight: 500;
  color: #333333;
  line-height: p2r(38px);
}

.img-role {
  width: p2r(22px);
  height: p2r(22px);
  margin-left: p2r(24px);
  margin-right: p2r(4px);
  line-height: p2r(38px);
}

.role_name {
  font-size: p2r(20px);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #2378E5;
}

.user_info_role {
  display: flex;
  align-items: center;
  font-size: p2r(20px);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
}

.user_info_proname {
  font-size: p2r(24px);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #999999;
  margin-top: p2r(20px);
}

// nav
.btninfo-wrap {
  display: flex;
  justify-content: space-around;
  width: 100%;
  background: #fff;
  border-radius: p2r(8px);
  // margin-top: p2r(10px);
  border-radius: 0 0 p2r(20px) p2r(20px);
  // padding:p2r(32px) p2r(44px) p2r(38px) p2r(44px);
  box-sizing: border-box;
  // background-color:#fff;
  box-shadow: 0px p2r(2px) p2r(11px) 0px rgba(225, 225, 226, 0.57);
  padding: p2r(30px) 0;
}

.btn-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.btn-img {
  width: p2r(68px);
  height: p2r(68px);
}

.btn-name {
  font-size: p2r(20px);
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  font-weight: 500;
  margin-top: p2r(4px);
}

// 围观
.watch {
  width: 90%;
  display: flex;
  padding: p2r(24px);
  background: #FFFFFF;
  box-shadow: 0px 2px p2r(11px) 0px rgba(225, 225, 226, 0.57);
  border-radius: p2r(20px);
  margin: p2r(20px) auto 0;
  box-sizing: border-box;
}

.watch-people {
  display: flex;
  align-items: center;
  flex: 1;
}

.watch-avatar {
  width: p2r(48px);
  height: p2r(48px);
  margin-right: p2r(6px);
}

.head8 {
  // display:flex;
  // justify-content :center;
  // align-items:center;
  width: p2r(48px);
  height: p2r(48px);
  text-align: center;
  line-height: p2r(32px);
  margin-right: p2r(6px);
  border-radius: 50%;
  background-color: #000;
  opacity: 0.7;
  color: #fff;
  font-weight: 800;
}

.watch-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.watch-p-nmber {
  font-size: p2r(24px);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #999999;
  margin-left: p2r(32px);
}

.watch-number {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: p2r(12px) p2r(21px);
  background: #F7F8F9;
  border-radius: p2r(10px);
  font-size: p2r(24px);
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #999999;
}

.watch-number .hot {
  width: p2r(18px);
  height: p2r(20px);
  margin-right: p2r(16px);
}

// 推荐户型
.house-title {
  width: 90%;
  margin: 0 auto;
  font-size: p2r(34px);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  padding: p2r(38px) 0 p2r(28px) 0;
}

.house {
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  margin: 0 auto;
}

.house-item {
  // width :33.33%;
  width: 50%;
  padding: p2r(10px);
  box-sizing: border-box;
  border-top-left-radius: 5px;
}

.house-item img {
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.house_tp {
  background-color: #E6E6E6;
  padding: p2r(20px);
  border-radius: 0 0 5px 5px;
}

.house_tags {
  display: flex;
  flex-wrap: wrap;
}

.house_tag {
  color: #101010;
  background-color: #FFFFFF;
  border-radius: 3px;
  margin-right: p2r(10px);
  padding: p2r(4px);
  font-size: p2r(32px);
  box-sizing: border-box;
  margin-bottom: p2r(8px);
}

.house_price {
  color: #E55617;
  font-size: p2r(32px);
}

// 咨询
.consult-wrap {
  position: fixed;
  right: p2r(30px);
  bottom: p2r(390px);
  z-index: 2;
}

.consult-wrap img {
  width: p2r(84px);
  height: p2r(84px);
  border-radius: 50%;
}

.consult-text {
  position: relative;
  margin-top: p2r(-30px);
  bottom: p2r(-10px);
  width: p2r(81px);
  height: p2r(30px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1676E9;
  border-radius: p2r(14px);
  color: #FFFFFF;
  font-size: p2r(20px);
  // margin-top :p2r(-40px);
  z-index: 10;
}

// 留电
.vcard4 /deep/ .van-overlay {
  z-index: 1990 !important;
}

.leaveTel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tel-title {
  width: 100%;
  // padding:p2r(20px);
  box-sizing: border-box;
  border-bottom: 1px solid #ecf0f5;
  font-size: p2r(20px);
  border-bottom: 1px solid #ecf0f5;
  font-size: 18px;
  color: #333333;
  text-align: center;
  height: 1.5rem;
  line-height: 1.5rem;
}

.tel-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: p2r(40px);
  box-sizing: border-box;
}

.tb-left {
  border-radius: 10px;
  background-color: #FFFFFF;
  width: 65%;
  color: #333333;
  font-size: 14px;
  text-align: center;
}

.tb-left input {
  width: 100%;
  height: p2r(80px);
  border: 1px solid #ECF0F6;
  border-radius: p2r(40px);
  text-indent: 15px;
  font-size: p2r(28px);
  background-color: #ffffff;
}

.tb-right {
  background-color: #2758E3;
  height: p2r(80px);
  width: 30%;
  text-align: center;
  color: #ffffff;
  font-size: p2r(28px);
  line-height: p2r(80px);
  border-radius: p2r(40px);
  margin-top: p2r(2px);
}
</style>
